module.exports = __webpack_public_path__ + "static/media/p11.f0bc52e8.webp";